import React, { useState } from 'react';
import { fetchNotifications } from '@/redux/notifications/notificationActions';
import { dontRemindEmailDisconnected, remindLaterEmailDisconnected } from '@/services/email.service';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import ButtonComponent from '../ButtonComponent/ButtonComponent';
import IconContainer from '../FtuxComponent/IconContainer';
import ModalComponent from './ModalComponent';

import './_partialActivePartnershipModal.scss';

import { GLEAP_PARTNERSHIP_ADDON_FORM_KEY, GLEAP_PARTNERSHIP_UPGRADE_FORM_KEY } from '@/utils/ts/gleap';
import dayjs from 'dayjs';
import Gleap from 'gleap';

interface PartialActivePartnershipModalProps {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
}

const PartialActivePartnershipModal: React.FC<PartialActivePartnershipModalProps> = ({ show, setShow }) => {
  const { userDetails } = useSelector((state: any) => state.user);

  const upgradePlan = async () => {
    Gleap.setTicketAttribute(
      'Intent',
      'I am approaching the quota of my active partnerships - need to upgrade my plan!'
    );
    Gleap.startClassicForm(GLEAP_PARTNERSHIP_UPGRADE_FORM_KEY, true);
  };

  const getPartnershipAddOn = async () => {
    Gleap.setTicketAttribute('Intent', 'I am approaching the quota of my active partnerships - need to get an add on!');
    Gleap.startClassicForm(GLEAP_PARTNERSHIP_ADDON_FORM_KEY, true);
  };

  const onDontRemindMe = () => {
    const unblockDate = dayjs(new Date()).add(7, 'days').toISOString();
    localStorage.setItem('partnership-modal-delay', unblockDate);
    setShow(false);
  };

  return (
    <ModalComponent show={show} onClose={() => setShow(false)} bodyStyle={{ padding: "32px 0px" }} style={{ padding: "0px 32px" }} width={520}>
      <div className="warning-modal modal-main-content">
        <IconContainer icon="⚠️" bgColor="rgb(255, 210, 24, 0.16)" />
        <h2 className="active-partnership-modal-header mt-4">Active Partnerships Approaching Quota...</h2>
        <div className="active-partnership-modal-body">
          <p className="active-partnership-body-text">
            The plan you are on right now gives you access to {userDetails?.featureLimit?.activePartnerships} active
            partnerships. Based on your account activity, you have hit 90% of that quota with{' '}
            {userDetails?.totalActivePartnerships} active partnerships right now.
          </p>
          <p className="active-partnership-body-text">
            You can choose to archive some old influencers if they aren&apos;t truly active.
          </p>
          <p className="active-partnership-body-text">
            If not, this is an alert to get more partnerships as an add-on or upgrade your plan.
          </p>
        </div>
        <div className="center active-partnership-modal-footer">
          <ButtonComponent
            onClick={getPartnershipAddOn}
            textStyle={{ fontSize: '16px' }}
            variant="secondary"
            style={{ height: '44px', padding: '10px 8px', width: '50%' }}>
            Get Partnership Add On
          </ButtonComponent>
          <ButtonComponent onClick={upgradePlan} style={{ height: '44px', width: '50%' }}>
            Upgrade my Plan
          </ButtonComponent>
        </div>
        <div
          className="underline"
          style={{
            paddingTop: '16px',
            paddingBottom: '0px',
            fontSize: '16px',
            cursor: 'pointer',
            color: 'var(--text-subdued)',
          }}
          onClick={onDontRemindMe}>
            Remind me later
        </div>
      </div>
    </ModalComponent>
  );
};

export default PartialActivePartnershipModal;
